import "../assets/link.scss";

/**
 * Компонент внешней ссылки. При нажатии ссылка открывается в новой вкладке.
 * @param {*} props 
 * @returns 
 */
export function LinkExternal(props) {
  const {to, children = []} = props;
  return <a href={to} className={'link'} target={'_blank'} rel={'noreferrer'}>{children}</a>;
}